import { modal } from "..";
import { locale } from "../locale";
import { Bulma } from "../view/bulma";
import { Html } from "../view/html";

/**
 * @param {string} productName 
 * @param {() => void} unregister 
 */
function openUnregisterDeviceModal(productName, unregister) {
        modal.open({
            header: locale.string({
                enGB: `Unregister ${productName}`,
                deDE: `${productName} abmelden`,
                frFR: `Désenregistrer ${productName}`,
                svSE: `Avregistrera ${productName}`,
            }),
            body: [
                Html.paragraph(locale.string({
                    enGB: `Confirm that you wish to unregister your ${productName}. Any remaining subscription time will be lost.`,
                    deDE: `Bestätigen Sie, dass Sie Ihr ${productName} abmelden möchten. Jede verbleibende Abonnementzeit geht verloren.`,
                    frFR: `Confirmez que vous souhaitez annuler l'enregistrement de votre ${productName}. Toute période d'abonnement restante sera perdue.`,
                    svSE: `Bekräfta att du vill avregistrera din ${productName}. Eventuell återstående prenumerationstid kommer att gå förlorad.`,
                }))
            ],
            footer: [
                Bulma.button(
                    {
                        onClick: unregister,
                        styles: ['is-danger'],
                    },
                    locale.strings.unregister,
                )
            ],
        })
}

export {
    openUnregisterDeviceModal,
}